import { BiometricDataResponse, BiometricDataUpdate } from "../../types/models/biometricData";

const API_URL = process.env.REACT_APP_API_URL || "http://localhost:8000";

export const getBiometricData = async (): Promise<BiometricDataResponse> => {
  const token = localStorage.getItem("authToken");

  if (!token) {
    throw new Error("Unauthorized: No token found.");
  }

  const response = await fetch(`${API_URL}/bio-data/`, {
    method: "GET",
    headers: {
      Authorization: `Bearer ${token}`,
    },
  });

  if (!response.ok) {
    throw new Error("Failed to fetch biometric data.");
  }

  return response.json();
};

export const updateBiometricData = async (
  data: Partial<BiometricDataUpdate>
): Promise<void> => {
  const token = localStorage.getItem("authToken");

  if (!token) {
    throw new Error("Unauthorized: No token found.");
  }

  const response = await fetch(`${API_URL}/bio-data/`, {
    method: "PUT",
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${token}`,
    },
    body: JSON.stringify(data),
  });

  if (!response.ok) {
    let errorMessage = "Failed to update biometric data.";
    try {
      const errorData = await response.json();
      errorMessage = errorData.message || errorMessage;
    } catch (err) {
      console.error("Failed to parse error response from biometric update:", err);
    }
    throw new Error(errorMessage);
  }


  return;
};

